import * as views from "../views";

export default [
  {
    path: "account/downgrade/:plan",
    name: "Downgrade",
    component: views.Downgrade,
  }
];
